<template>
  <v-app id="app">
    <router-view/>
    <v-dialog v-model="dialog.isShow" max-width="290" hide-overlay>
      <v-card>
        <v-card-title>{{dialog.isLoading ? '' : dialog.title}}</v-card-title>
        <v-card-text v-if="dialog.isLoading" class="d-flex justify-center">
          <v-progress-circular indeterminate :size="75" color="primary"></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>{{dialog.content}}</v-card-text>
        <v-card-actions v-if="dialog.isLoading" ></v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" text @click="dialog.isShow = false">取消</v-btn> -->
          <v-btn color="primary" text @click="closeDialog">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'App',
  data: () => ({
  }),
  methods: {
    ...mapMutations({
      closeDialog: 'CLOSE_DIALOG'
    })
  },
  computed: {
    ...mapGetters(['dialog'])
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
